import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9205cd5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper flex w-full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "banner-text flex-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-title" }, "Trade & Earn", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-subtitle" }, "Get Up to 500 000 Spice points + BTC", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/banners/trading-competition/logos-mobile.png",
  alt: "",
  class: "logos"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { GYDDE_LINK } from '@/constants/EXTERNAL_LINKS';
import { useUtils } from '@/composables/utils/useUtils';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradingCompetitionBanner',
  setup(__props) {

const { state } = useStore();
const { openExternalLink } = useUtils();

const bgImg = computed(() => {
  return [
    `/images/banners/trading-competition/bg-left-${state.layout.viewMode}.png`,
    `/images/banners/trading-competition/bg-right-${state.layout.viewMode}.png`,
  ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "banner relative",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openExternalLink)(_unref(GYDDE_LINK))))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bgImg), (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "inline-flex"
        }, [
          _createElementVNode("img", {
            src: image,
            alt: "",
            class: "coins"
          }, null, 8, _hoisted_2)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})